// extracted by mini-css-extract-plugin
module.exports = {"layout":"_3JyDmH-XTemz_WEfCvZwvm"};